import gql from "graphql-tag";

export default gql`
	mutation deleteBackOfficeUser($user_id: ID!) {
		deleteBackOfficeUser(userId: $user_id) {
			success
		}
	}
`;
